import HttpCliente from "../servicios/HttpCliente";

export const saveMeasurerAction = (measurer) => {
  return HttpCliente.post("/measurers", measurer);
};

export const getListMeasurerAction = (associateId) => {
  return HttpCliente.get("/measurers/list", associateId);
};

export const deleteMeasurerAction = (measurerId) => {
  return HttpCliente.delete('/measurers/delete/' + measurerId);
};

export const updateMeasurerAction = (measurerId, measurer) => {
  return HttpCliente.put('/measurers/' + measurerId, measurer);
};

export const getListMeasurerSearch = (request) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/measurers/search", request)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getNextMeasurerCode = () => {
  return new Promise((resolve, reject) => {
    HttpCliente.getOnly("/measurers/next-code")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
